import React from 'react';
import './Projects.css';
import ProjectCard from './ProjectCard';

const projectsData = [
  {
    id: 1,
    number: '01',
    title: 'Sales Forecast ML Model',
    description: 'Architected a time-series forecasting pipeline using LightGBM and Scikit-learn, achieving an RMSE of ~3160 through rigorous feature engineering.',
    techStack: ['Python', 'Scikit-learn', 'Pandas', 'Numpy', 'Matplotlib', 'LightGBM'],
    direction: 'left'
  },
  {
    id: 2,
    number: '02',
    title: 'Real-time Profile Management',
    description: 'Developed a secure, responsive user management system using the MERN stack, featuring custom Express.js API routing and persistent MongoDB storage.',
    techStack: ['React', 'Tailwind', 'DaisyUI', 'Node.js', 'Express.js', 'MongoDB'],
    direction: 'top'
  },
  {
    id: 3,
    number: '03',
    title: 'Air Traffic Control Simulator',
    description: 'Engineered a multithreaded JavaFX application to simulate complex flight patterns and coordination in a thread-safe environment.',
    techStack: ['Java', 'JavaFX'],
    direction: 'right'
  }
];

const Projects = () => {
  return (
    <section id="projects" className="projects">
      <div className="projects__container">
        <h2 className="projects__heading">Featured Projects</h2>
        <div className="projects__grid">
          {projectsData.map((project, index) => (
            <ProjectCard 
              key={project.id}
              project={project}
              delay={index * 0.2}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
